<template>
	<div>
		<general-filter class="layout wrap" :class="{ 'column px-0' : column, 'px-5 mt-4' : !column }">
			<v-flex xs12 
				:class="{ 'sm3' : !column, 'full-width' : column }"
				class="filter-company"
				v-if="!hidenCompany">
				<BaseSelect
					autocomplete
					return-object
					item-text="name"
					item-value="id"
					label="Empresa"
					:height="33"
					:items="companies"
					:value="newSubsidiaryId"
					@input="setData($event, 'subsidiaryId')"
				/>
			</v-flex>
			<v-flex xs12 :class="{ 'sm3' : !column, 'full-width' : column }" class="filter-company">
				<BaseSelect
					solo
					return-object
					label="Año"
					item-text="year"
					item-value="id"
					:disabled="disabledYears"
					:height="33"
					:items="years"
					:value="newYearId"
					@input="setData($event, 'yearAccountantId')"
				/>
			</v-flex>
		</general-filter>
	</div>
</template>

<script>
	function setData(val, model) {
		this.$emit('filter', { value: val, model });
	}

	function newSubsidiaryId() {
		return this.subsidiaryId;
	}

	function newYearId() {
		return this.yearAccountantId;
	}

	export default {
		name: 'accounting-filter',
		components: {
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
		},
		computed: {
			newSubsidiaryId,
			newYearId,
		},
		methods: {
			setData,
		},
		props: {
			column: {
				default: false,
				type: Boolean,
			},
			companies: {
				default: () => [],
				type: Array,
			},
			disabledYears: {
				default: false,
				type: Boolean,
			},
			subsidiaryId: [Number, String],
			yearAccountantId: [Number, String],
			years: {
				default: () => [],
				type: Array,
			},
			hidenCompany: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.full-width {
		width: 100%;
	}

	.filter-company {
		margin: 0 30px 0 0;

		@media (max-width: 768px) {
			margin: 0 0 30px 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/accounting-plans/accounting-filter.vue